import { Box, Container, Grid, makeStyles } from "@material-ui/core";
import {
  Dispatch,
  FC,
  SetStateAction,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import ProjectPoolHeading from "./ProjectPoolHeading";
import { Colors } from "../../helpers/theme";
import LivePools from "./LivePools";
import ClosedPools from "./ClosedPools";
import PoolContext from "../../store/Pool/PoolContext";
import AlertContext from "../../store/Alert/AlertContext";
import AuthContext from "../../store/Auth/AuthContext";
import ClosedPoolsDesktopView from "./ClosedPoolsDesktopView";
import LearnContext, { useLearnContext } from "../../store/Learn2/LearnContext";
import StakingRequiredModal from "../Modals/StakingRequiredModal";
import EmptyFundedProject from "./empty-funded-project";
// TODO: Define TabPanel props type.

const useStyles = makeStyles((theme) => ({
  tab: {
    width: "fit-content",
    minWidth: "auto",
    backgroundColor: Colors.white,
    color: Colors.greySlate,
    fontSize: "1rem",
    fontWeight: 500,
    padding: "5px 20px",
    textTransform: "none",
    border: "1px solid rgba(17, 48, 45, 0.1)",
    borderRadius: "36px",
    "&:hover": {
      backgroundColor: Colors.secondaryWhite,
      color: Colors.greySlate,
    },
    "&.Mui-selected": {
      backgroundColor: Colors.greenDark,
      color: Colors.white,
    },
  },
  tabPanel: {
    marginBottom: "5px",
  },
}));

// function a11yProps(index: number) {
//     return {
//       id: `scrollable-auto-tab-${index}`,
//       'aria-controls': `scrollable-auto-tabpanel-${index}`,
//     };
//   }

interface PoolsContainerProps {
  setOpenLoginModal: Dispatch<SetStateAction<boolean>>;
  livePop: any;
  singleProjectPop: any;
  statusPop: any;
  closedPop: any;
}

const PoolsContainer: FC<PoolsContainerProps> = ({
  setOpenLoginModal,
  livePop,
  singleProjectPop,
  statusPop,
  closedPop,
}) => {
  const classes = useStyles();

  const liveRef = useRef<any>(null);
  const singleRef = useRef<any>(null);
  const closedRef = useRef<any>(null);

  const { isAuth } = useContext<any>(AuthContext);
  const {
    livePools: pools,
    livePoolsError: error,
    closedPoolsError,
    userPledges,
    getUserListPledge,
  } = useContext<any>(PoolContext);
  const { setAlert } = useContext<any>(AlertContext);
  const { activeQuizzes, getAuthUserPoolQuiz } = useLearnContext();

  const [showStakingRequired, setShowStakingRequired] = useState(false);
  const [pledgeData, setPledgeData] = useState();

  const stakingPopup = localStorage.getItem("staking-popup");


  useEffect(() => {
    if (stakingPopup) {
      setShowStakingRequired(true);
      localStorage.removeItem("staking-popup");
    }
  }, [stakingPopup]);

  useEffect(() => {
    livePop(liveRef);
    singleProjectPop(singleRef);
    closedPop(closedRef);
  }, []);

  useEffect(() => {
    if (pools) {
      if (isAuth) {
        getUserListPledge();
        getAuthUserPoolQuiz();
        // TODO: Set popover and explainers - check localStorage previouslyVisited
      }
    }
  }, [pools, isAuth]);

  useEffect(() => {
    if (userPledges) {
      setPledgeData(userPledges);
    }
  }, [userPledges]);

  return (
    <Container
      maxWidth="lg"
      style={{
        marginTop: "20px",
        marginBottom: "20px",
      }}
    >
      <Grid container direction="column">
        <Grid item ref={liveRef}>
          <ProjectPoolHeading title1="Current" title2="Deals" />
        </Grid>
        <Grid item className={classes.tabPanel} ref={singleRef}>
          <LivePools
            quizzes={activeQuizzes ?? []}
            pledgeData={isAuth ? pledgeData : null}
            key="LivePools"
            setOpenLoginModal={setOpenLoginModal}
            statusPop={statusPop}
          />
        </Grid>
        <FundedProjects />
      </Grid>
      {showStakingRequired && (
        <StakingRequiredModal
          open={showStakingRequired}
          setOpen={setShowStakingRequired}
        />
      )}
    </Container>
  );
};

const FundedProjects = () => {
  const closedRef = useRef<any>(null);

  const { closedPoolsPaginated: endedPools, isClosedPoolsLoading } =
    useContext<any>(PoolContext);

  const totalFundedProjects = endedPools?.length ?? 0;

  return (
    <>
      <Box mt={{ lg: 5 }}>
        <Grid item ref={closedRef}>
          <ProjectPoolHeading title1="Funded" title2="Projects" />
        </Grid>
        {!isClosedPoolsLoading && endedPools && totalFundedProjects === 0 ? (
          <EmptyFundedProject />
        ) : (
          <Grid item md={12} sm={12} xs={12}>
            <Box
              display={{
                xs: "none",
                sm: "none",
                md: "none",
                lg: "block",
                xl: "block",
              }}
            >
              <ClosedPoolsDesktopView />
            </Box>
            <Box
              display={{
                xs: "flex",
                sm: "flex",
                md: "flex",
                lg: "none",
                xl: "none",
              }}
              flexDirection="column"
            >
              <ClosedPools key="ClosedPools" dealPage={true} />
            </Box>
          </Grid>
        )}
      </Box>
    </>
  );
};

export default PoolsContainer;
